import { gql } from "@apollo/client";

export const typeDef = gql`
  type Ranking {
    id: String
    rank: Int
    meta: MediaMeta
  }

  type Query {
    ranking(target: String, range: String, channel: Int, count: Int): [Ranking]
  }
`;

export const resolvers = {
  Query: {
    ranking: async (
      _parent,
      { target, range, channel, count },
      { dataSources }
    ) => {
      const res = await dataSources.meta.rankingSearch(
        channel,
        target,
        range,
        count
      );
      const ranking = res.metas.map((meta, i) => {
        const rank = i + 1;
        return { id: `${rank}-${meta.id}`, rank, meta };
      });
      return ranking;
    },
  },
};
